import { render, staticRenderFns } from "./SpectatorHome.vue?vue&type=template&id=58bb7ee6&"
import script from "./SpectatorHome.vue?vue&type=script&lang=ts&"
export * from "./SpectatorHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports